import styled from 'styled-components';

export const RadioWrapper = styled.div`
	position: relative;
`;

export const RadioView = styled.div`
	width: 16px;
	height: 16px;
	border-radius: 50%;
	border: 2px solid rgb(233, 233, 233);
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-top: -20px;
`;

export const RadioViewBackground = styled.div`
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background: white;

	&.checked {
		background: rgba(147,228,182,1);
	}
`;

export const Radio = styled.input`
	opacity: 0;
	cursor: pointer;
`;

export const RadioLabel = styled.label`
	cursor: pointer;
`;
